// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"a80a70b7","282":"4713b99f","328":"e701aa07","380":"128d1896","564":"57e17c29"}[chunkId] + ".css";
};